module.exports = __webpack_public_path__ + "static/media/polygon.com_2016_7_6_12105992_pokemon-go-guide-faq-ios-android_plot.d2ed7685.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/polygon.com_2016_7_6_12105992_pokemon-go-guide-faq-ios-android_plot.png
// module id = 417
// module chunks = 0